(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bnpl"] && !Shopify.designMode) return;
  try {
    const details = document.querySelector(".custom_bnpl_display_block>details")
    const details__summary = details.querySelector("summary")
    const details__content = details.querySelector(".bnpl_card__content")

    //handle interactions
    details.addEventListener("mouseleave", (e)=> {
        details.removeAttribute("open")
    })

    document.addEventListener("scroll", (e)=> {
        details.removeAttribute("open")
    })

    //handle data

    // window.addEventListener("load", (event) => {
    //     const option_values = details__content.querySelectorAll("[data-installment-value]")
        
    //     let largest_value = parseInt(option_values[0].dataset.installmentValue)

    //     Array.from(option_values).forEach(value => {
   
    //         if (parseInt(value.dataset.installmentValue) < largest_value) {
    //             largest_value = parseInt(value.dataset.installmentValue)
    //         }
    //     })

    //     const largest_value__formatted = parseFloat(largest_value / 100)


    //     if (largest_value__formatted !== NaN) {
    //         details.querySelector(".bnpl_card__lowest_value").innerText = ` - from R${largest_value__formatted}`
    //     }
    // });
    let is_data_ready = false
    
    //
    window.addEventListener("bnpl_loaded", (e) => {
        is_data_ready = true
    })

    const start_time = Date.now()
    const data_interval = setInterval(() => {
        if (is_data_ready) {
            const option_values = details__content.querySelectorAll("[data-installment-value]")
        
            let largest_value = parseInt(option_values[0].dataset.installmentValue)

            Array.from(option_values).forEach(value => {
    
                if (parseInt(value.dataset.installmentValue) < largest_value) {
                    largest_value = parseInt(value.dataset.installmentValue)
                }
            })

            const largest_value__formatted = parseFloat(largest_value / 100)


            if (largest_value__formatted !== NaN) {
                const fromValSpan = details.querySelector(".bnpl_card__lowest_value")
                if (fromValSpan.dataset.instock === "true") {
                    fromValSpan.innerText = ` - from R${largest_value__formatted}`
                }
            }

            clearInterval(data_interval)
        } else if (Date.now() - start_time >= 5000) {
            clearInterval(data_interval)
        }
    }, 500)
  } catch(e) { console.error(e); }
})();

})();
